import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

/**
 * Tooltip component using Tippy.js
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The trigger element
 * @param {string|React.ReactNode} props.content - Tooltip content
 * @param {string} props.placement - Placement of tooltip (default: 'top')
 * @param {number} props.delay - Delay before showing (default: 200ms)
 * @param {boolean} props.disabled - Whether tooltip is disabled
 */
export function Tooltip({
  children,
  content,
  placement = 'top',
  delay = 200,
  disabled = false
}) {
  if (disabled || !content) {
    return children;
  }

  return (
    <Tippy
      content={content}
      placement={placement}
      delay={[delay, 0]}
      className="!bg-stone-800 !text-white !text-xs !rounded-lg !px-2 !py-1"
      arrow={false}
    >
      <span className="inline-flex">{children}</span>
    </Tippy>
  );
}
